import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class ClearButton extends Component {
  constructor(props) {
    super(props);
    this.handleClearClick = this.handleClearClick.bind(this);
  }

  handleClearClick() {
    this.props.restoreProviderManualOrder();
  }

  render() {
    return (
      <Button secondary
        disabled={this.props.loading}
        content='LIMPIAR'
        onClick={this.handleClearClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.providerManualOrder.loading,
  };
};

const {restoreProviderManualOrder} = Actions;

export default connect(mapStateToProps, {
  restoreProviderManualOrder,
})(ClearButton);
